import { useQuery } from "react-query";
import Select from "react-select"


import { getBranches } from "../../../../../MyApi/sb/branches";
import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getEmployes } from "../../../../../MyApi/sb/employes";


import icons from "../../../../../Data/icons";

import classes from "./addDepartment.module.css";


const EditDepartment= ({sb_branch_id, sb_company_id,sb_employe_id,setCompanyId,
  active, setActive,name, setName, description, setDescription, setEmployId, setBranchId, 
}) => {
 

const branchesQuery= useQuery("getBranch", getBranches)
const companyQuery = useQuery("getcompanies" , getCompanies)
const employQuery = useQuery("getEmployes" ,  getEmployes)


const companies =companyQuery.data?.data || []
const branches = branchesQuery.data?.data || []
const employes = employQuery.data?.data || []


  const Company = icons.company
  const City = icons.City
  const Branch = icons.branch

  const defaultCompanies= companies.find((option=>option.id ===sb_company_id))
  const defaultBranches= branches.find((option=>option.id ===sb_branch_id))
  const defaultEmployes = employes.find((option)=>option.id === sb_employe_id)

  const handleNameChange = (e) => {
    setName(e.target.value);
  };
 const handleDescription =(e)=>{
  setDescription(e.target.value)
 }
   const handleEmployIdChange=(e)=>{
  setEmployId(e.target.options[e.target.selectedIndex].id)
 }

  const handleCompanyIdChange =(e)=>{
    setCompanyId(e.target.options[e.target.selectedIndex].id)
  }
  const handleBranchesId =(e)=>{
    setBranchId(e.target.options[e.target.selectedIndex].id)
  }
  const handleActiveChange =(e)=>{
   const isChecked = e.target.checked
    setActive(isChecked ? 1:0)
  }





  return (
    <div className={classes.formCard}>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم القسم</label>
          <div className={classes.iconInput}>
            <Branch />
          </div>
          <input
            type="text"
            value={name}
            placeholder="ادخل اسم القسم"
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">الوصف </label>
          <div className={classes.iconInput}>
            <Branch />
          </div>
          <textarea
            type="text"
            value={description}
            placeholder="ادخل  الوصف"
            onChange={handleDescription}
            className={classes.inputCustom}
          > </textarea>
        </div>



        <div className={classes.formCol}>
          <label htmlFor="company">  اختار الشركة</label>
        {!companyQuery.data ?<div> no data available</div> :
        <Select
            type="text"
            placeholder="اختار الشركة"
            defaultValue={defaultCompanies}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name}
            options={companies}
            onChange={handleCompanyIdChange}        
          />
          }
        </div>
        <div className={classes.formCol}>
          <label htmlFor="company">  اختار الموظف</label>
        {!employQuery.data ?<div> no data available</div> :
        <Select
            type="text"
            placeholder="اختار الموظف"
            defaultValue={defaultEmployes}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name_ar}
            options={employes}
            onChange={handleEmployIdChange} 
         />
          }
        </div>

        <div className={classes.formCol}>
          <label htmlFor="city">  اختار الفرع</label>
         {!branchesQuery.data ? <div>no data avalible</div> :
          <Select
            type="text"
            placeholder="اختار الفرع"
            defaultValue={defaultBranches}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name}
            options={branches}
            onChange={handleBranchesId}    
          />
           }
        </div>


        <div className={classes.formCol}>
          <label htmlFor="active"  className={active ? `${classes.active}` : `${classes.disActive}`}>   {active===1 ?" نشط":"غير نشط"} </label>
 
         <label class="switch">
          <input type="checkbox" onChange={handleActiveChange} checked={active}/>
            <span class="slider round"></span>
        </label> 
    
           </div>

        
    </div>
    </div>
  );
};

export default EditDepartment;
